import React from "react";
import styles from "./ForecastHeader.module.css";
import Button from "../../components/common/Button";
import { useProfileStore } from "../../store/profileStore";
import { useNatalChartStore } from "../../store/natalChartStore";
import { useNavigate } from "react-router-dom";
import { getZodiacSign } from "../../utils/zodiacUtils";

// Соответствия трёхбуквенных и полных русских знаков:
const ZODIAC_SHORT_TO_RU: Record<string, string> = {
  Ari: "Овен",
  Tau: "Телец",
  Gem: "Близнецы",
  Can: "Рак",
  Leo: "Лев",
  Vir: "Дева",
  Lib: "Весы",
  Sco: "Скорпион",
  Sag: "Стрелец",
  Cap: "Козерог",
  Aqu: "Водолей",
  Pis: "Рыбы",
};

const ELEMENTS: Record<string, string> = {
  Овен: "Огонь",
  Лев: "Огонь",
  Стрелец: "Огонь",
  Телец: "Земля",
  Дева: "Земля",
  Козерог: "Земля",
  Близнецы: "Воздух",
  Весы: "Воздух",
  Водолей: "Воздух",
  Рак: "Вода",
  Скорпион: "Вода",
  Рыбы: "Вода",
};
const POLARITIES: Record<string, string> = {
  Овен: "Мужская",
  Близнецы: "Мужская",
  Лев: "Мужская",
  Весы: "Мужская",
  Стрелец: "Мужская",
  Водолей: "Мужская",
  Телец: "Женская",
  Рак: "Женская",
  Дева: "Женская",
  Скорпион: "Женская",
  Козерог: "Женская",
  Рыбы: "Женская",
};
const MODALITIES: Record<string, string> = {
  Овен: "Кардинальный",
  Рак: "Кардинальный",
  Весы: "Кардинальный",
  Козерог: "Кардинальный",
  Телец: "Фиксированный",
  Лев: "Фиксированный",
  Скорпион: "Фиксированный",
  Водолей: "Фиксированный",
  Близнецы: "Мутабельный",
  Дева: "Мутабельный",
  Стрелец: "Мутабельный",
  Рыбы: "Мутабельный",
};
const ZODIAC_IMAGE_NAMES: Record<string, string> = {
  Овен: "aries",
  Телец: "taurus",
  Близнецы: "gemini",
  Рак: "cancer",
  Лев: "leo",
  Дева: "virgo",
  Весы: "libra",
  Скорпион: "scorpio",
  Стрелец: "sagittarius",
  Козерог: "capricorn",
  Водолей: "aquarius",
  Рыбы: "pisces",
};

const ForecastHeader: React.FC = () => {
  const navigate = useNavigate();
  const profile = useProfileStore((s) => s.profile);
  const natalChart = useNatalChartStore((s) => s.natalChart);

  if (!profile) return null;

  const birthDate = new Date(profile.dob);
  const sunSign = getZodiacSign(birthDate);

  // Вытаскиваем moon/ascendant из стора, если есть
  const moonShort = natalChart?.details?.moon_sign || "";
  const ascShort = natalChart?.details?.ascendant_sign || "";

  const moonSign = ZODIAC_SHORT_TO_RU[moonShort] || "—";
  const ascSign = ZODIAC_SHORT_TO_RU[ascShort] || "—";

  const element = ELEMENTS[sunSign] || "-";
  const polarity = POLARITIES[sunSign] || "-";
  const modality = MODALITIES[sunSign] || "-";
  const zodiacImageName = ZODIAC_IMAGE_NAMES[sunSign] || "aries";
  const imagePath = `/zodiac/${zodiacImageName}-big.svg`;

  return (
    <div className={styles.headerWrapper}>
      <div className={styles.characteristicsBlock}>
        <div className={styles.characteristic}>
          <div className={styles.label}>Солнце</div>
          <div className={styles.value}>{sunSign}</div>
        </div>
        <div className={styles.characteristic}>
          <div className={styles.label}>Луна</div>
          <div className={styles.value}>{moonSign}</div>
        </div>
        <div className={styles.characteristic}>
          <div className={styles.label}>Асцендент</div>
          <div className={styles.value}>{ascSign}</div>
        </div>
      </div>
      {/* АВАТАР */}
      <div className={styles.block}>
        <div className={styles.avatarBlock}>
          <img src={imagePath} alt={sunSign} className={styles.avatar} />
        </div>
        <Button className={styles.ctaButton} onClick={() => navigate("/natal-chart")}>
          Натальная карта
        </Button>
      </div>
      <div className={styles.characteristicsBlock}>
        <div className={styles.characteristic}>
          <div className={styles.label}>Стихия</div>
          <div className={styles.value}>{element}</div>
        </div>
        <div className={styles.characteristic}>
          <div className={styles.label}>Полярность</div>
          <div className={styles.value}>{polarity}</div>
        </div>
        <div className={styles.characteristic}>
          <div className={styles.label}>Модальность</div>
          <div className={styles.value}>{modality}</div>
        </div>
      </div>
    </div>
  );
};

export default ForecastHeader;
